import React from 'react';
import I18n from 'i18n-js';
import { buttonClassName, RCButton } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { CartClickInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../schemas/rql';
import { useExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import { useTrackCheckoutClickEvent } from '../lib/checkoutTracking';
import { CheckoutGuestAuthModal } from './CheckoutGuestAuthModal';
import { guestCheckoutExperiments, showGuestAuthModal } from '../lib/guestCheckout';
import experiments from '@reverbdotcom/commons/src/experiments';

interface Props {
  paymentMethodType: CheckoutPaymentMethodType;
  checkoutPath: string;
}

export default function CartStartCheckoutButton(props: Props) {
  const user = useUser();
  const [isModalOpen, setModalOpen] = React.useState(false);
  const showGuestAuthModalButton = useGuestAuthModalButton(props.paymentMethodType);
  const trackEvent = useTrackCheckoutClickEvent(
    {
      id: null,
      paymentMethod: {
        type: props.paymentMethodType,
      },
    },
    guestCheckoutExperiments(user, props.paymentMethodType),
  );

  function openModal() {
    setModalOpen(true);
    trackEvent(CartClickInteraction.StartCheckout);
    trackEvent(CartClickInteraction.OpenAuthModal);
  }

  function closeModal() {
    setModalOpen(false);
    trackEvent(CartClickInteraction.CloseAuthModal);
  }

  function button() {
    if (showGuestAuthModalButton) {
      return (
        <>
          <RCButton
            variant="primary"
            onClick={openModal}
            fullWidth
          >
            <ButtonContent />
          </RCButton>
          <CheckoutGuestAuthModal
            active={isModalOpen}
            redirectTo={props.checkoutPath}
            onRequestClose={closeModal}
            trackSource="Cart"
          />
        </>
      );
    }

    return (
      <CoreLink
        to={props.checkoutPath}
        className={buttonClassName({ variant: 'primary', fullWidth: true })}
        onClick={() => trackEvent(CartClickInteraction.StartCheckout)}
      >
        <ButtonContent />
      </CoreLink>
    );
  }

  return (
    <div className="mobile-width-100">
      {button()}
    </div>
  );
}

function ButtonContent() {
  const buttonText = I18n.t('discovery.checkout.cart.startCheckout');
  const inCheckoutArrowExp = useExpEnabled(experiments.CART_CHECKOUT_BUTTON);

  return (
    <>
      {buttonText}
      {inCheckoutArrowExp &&
        <span className="icon-r-arrow-right" />
      }
    </>
  );
}

function useGuestAuthModalButton(paymentMethodType: CheckoutPaymentMethodType) {
  return showGuestAuthModal(useUser(), paymentMethodType);
}
